import * as React from "react";
const SvgFiRrHandBackPointLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-back-point-left_svg__a)">
      <path
        fill="#062147"
        d="M19 22h-4.72a5.014 5.014 0 0 1-4.904-4.019L8.18 12H3.107C1.591 12 .273 10.924.041 9.497a3.01 3.01 0 0 1 .674-2.439 3 3 0 0 1 2.286-1.057l7.274.02 3.92-3.945a3.62 3.62 0 0 1 2.575-1.075h.006c.972 0 1.886.378 2.573 1.066l2.308 2.308A7.95 7.95 0 0 1 24 10.032v6.969A5.005 5.005 0 0 1 19 22M2.997 8a1 1 0 0 0-.759.353c-.193.228-.272.52-.224.823.076.462.556.825 1.093.825H9c.477 0 .887.336.98.804l1.357 6.785a3.01 3.01 0 0 0 2.942 2.412H19c1.654 0 3-1.346 3-3v-6.969c0-1.603-.624-3.11-1.757-4.243l-2.308-2.308c-.31-.31-.728-.52-1.162-.48-.439 0-.85.172-1.16.484L13.084 6.03l3.917.011a1 1 0 0 1-.003 2h-.003l-14-.039z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-back-point-left_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandBackPointLeft;
